import * as React from 'react';
import { noop } from 'es-toolkit';

import clsx from 'clsx';

import { ifClickable } from '../../utils/touchUtils';

interface Props {
  'aria-label'?: string;
  children?: React.ReactNode;
  className?: string;
  'data-testid'?: string;
  disabled?: boolean;
  hidden?: boolean;
  onFocus?(): void;
  onClick?(event: React.MouseEvent<HTMLElement>): void;
  role?: React.AriaRole;
}

/**
 * @deprecated Prefer a Pantry component instead. See https://docs.tocktix.com/pantry.
 * If an equivalent component doesn't exist yet, reach out in #pantry-design-system on Slack.
 */
export default class InputContainer extends React.PureComponent<Props> {
  render() {
    const {
      'aria-label': ariaLabel,
      children,
      className: classNameFromProps,
      disabled,
      hidden,
      onClick,
      onFocus,
      role,
    } = this.props;

    const className = clsx('InputContainer', classNameFromProps, {
      'is-disabled': disabled,
      'is-hidden': hidden,
    });

    const clickHandler = !disabled ? ifClickable(onClick) : noop;
    // TODO

    return (
      <div
        aria-label={ariaLabel}
        className={className}
        data-testid={this.props['data-testid']}
        onFocus={onFocus}
        onClick={clickHandler}
        role={role}
      >
        {children}
      </div>
    );
  }
}
